import { useIntl } from "react-intl";
import { License } from "../../api/decimal/common-types/manageAssets.ts";

export default function ExpiredMessage({
  license,
  className,
}: {
  license: License;
  className?: string;
}) {
  const intl = useIntl();

  if (license.expired) {
    return (
      <div className={className}>
        {intl.formatMessage(
          {
            defaultMessage: "Expired {expirationDate, date, mm/dd/yyyy}",
          },
          { expirationDate: new Date(license.expiresAt) }
        )}
      </div>
    );
  }
}
